import { apiRequest } from './api';

export const CuratedListsService = {
    async list(params = {}) {
        return apiRequest('/curated-lists', { params });
    },

    async get(slug) {
        return apiRequest(`/curated-lists/${slug}`);
    },

    async getForMedia(kind, tmdbId, params = {}) {
        return apiRequest(`/curated-lists/media/${kind}/${tmdbId}`, { params });
    },

    async addUnwatchedToWatchlist(slug) {
        return apiRequest(`/curated-lists/${slug}/watchlist/unwatched`, {
            method: 'POST',
        });
    },
};
